namespace TR {
    class FareRulesText {
        text:string;
        constructor(private modalService:any){
            this.text = this.modalService.get('fareRulesText');
        }
    }
    angular
        .module('TR')
        .directive('fareRulesText', function(modalService) {
            return {
                restrict: 'E',
                controllerAs: 'frt',
                controller: FareRulesText,
                template: '<div ng-bind-html="frt.text"></div>'
            };
        });

}
